import Drawable from './Drawable.js';
import { getOSM } from '../OverworldAnimation.js';

export default class DiagonalMovementControl extends Drawable {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            direction: this.direction,
            position: this.position,
        };
    }

    static deserialize(data) {
        return new DiagonalMovementControl({
            direction: data.direction,
            position: data.position,
        });
    }

    constructor({ direction, position, OSM, GUI }) {
        super({ position, OSM, GUI });
        this.visible = true;
        this.width = 16;
        this.height = 16;
        this.xModifier = 0;
        this.yModifier = 0;
        this.direction = direction;
        this.OSM = OSM;
        this.GUI = GUI;
    }

    entered() {
        const playerPosition = getOSM().player.position;
        const didEnter =
            playerPosition.x === this.position.x &&
            playerPosition.y === this.position.y &&
            this.position.z === playerPosition.z;
        return didEnter;
    }

    draw() {}
}
